import {inject} from '@angular/core';
import {CanActivateFn} from '@angular/router';
import {AuthService} from './auth.service';
import {APP_CONFIG} from "../app.config";

/**
 * Guard for admin routes.
 * Redirects to login if the user is not an admin.
 */
export const adminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const appConfig = inject(APP_CONFIG);

  if (authService.isUserAdmin()) {
    return true;
  }
  window.open(appConfig.loginUrl, '_self');
  return false;
};
